import Vue from "vue"
import VueRouter from "vue-router"
import store from "../store"
import system from "./system"
import cooperationApplication from "./cooperationApplication"
import franchisee from "./franchisee"
import announcement from "./announcement"
import businessInformation from "./businessInformation"
import settlement from "./settlement"
import supplier from "./supplier"
import opinion from "./opinion"
import device from "./device"
import marketing from "./marketing"
import customerRelations from "./customerRelations"
import product from "./product"
import storeManage from "./storeManage"
import orderManage from "./orderManage"
import inventory from "./inventory"
import formalProject from "./formalProject"
import personnelMatters from "./personnelMatters"
import experienceProject from "./experienceProject"
import carouselManage from "./carouselManage"
import reserveManage from "./reserveManage"
import activity from "./activity"
import customerService from "./customerService"
import user from "./user"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    component: () => import("../views/Main"),
    meta: { title: "管理后台" },
    children: [
      ...system,
      ...cooperationApplication,
      ...franchisee,
      ...announcement,
      ...businessInformation,
      ...settlement,
      ...supplier,
      ...customerRelations,
      ...device,
      ...marketing,
      ...opinion,
      ...product,
      ...storeManage,
      ...orderManage,
      ...inventory,
      ...formalProject,
      ...personnelMatters,
      ...experienceProject,
      ...carouselManage,
      ...reserveManage,
      ...activity,
      ...customerService,
      ...user,
      // {
      //   path: '/home',
      //   name: '/home',
      //   component: () => import('../views/Home'),
      //   meta: { title: 'Home' },
      // },
      {
        path: "/personals",
        name: "personals",
        component: () => import("../views/Personals"),
        meta: { title: "个人信息" },
      },
    ],
  },
  {
    path: "/login",
    name: "/login",
    component: () => import("../views/Login"),
    meta: { title: "管理后台-登录" },
  },
  {
    path: "/forgotPassword",
    name: "forgotPassword",
    meta: { title: "忘记密码" },
    component: () => import("../views/forgotPassword.vue"),
  },
  {
    path: "/404",
    name: "404",
    meta: { title: "服务器拒绝访问或页面不存在" },
    component: () => import("../views/404"),
  },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

const originaPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originaPush.call(this, location).catch(err => err)
}

router.beforeEach((to, form, next) => {
  const token = store.state.token
  if (to.path == "/register" || to.path == "/forgotPassword") {
    next()
  } else if (!token && to.path !== "/login") {
    store.dispatch("logout")
    next("/login")
  } else if (token && to.path == "/login") {
    store.dispatch("logout")
    localStorage.clear()
    next()
  } else {
    next()
  }
})

router.afterEach(to => {
  if (to.meta.title) document.title = to.meta.title
})

export default router
